import { useEffect } from 'react';

import { useAuth } from '@/features/auth/hooks/useAuth';
import { useSharedSocket } from '@/features/calls/context/CallContext';

/**
 * When the current professional is suspended by an admin, the server emits
 * `professional:suspended` to their user room. Log them out immediately.
 */
export function useSuspensionForceOut(): void {
  const { logout } = useAuth();
  const socket = useSharedSocket();

  useEffect(() => {
    if (!socket) return;
    const handler = (): void => {
      void logout();
      window.location.href = '/login?suspended=1';
    };
    socket.on('professional:suspended', handler);
    return () => {
      socket.off('professional:suspended', handler);
    };
  }, [socket, logout]);
}
